<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>运营回访统计</span>
          </div>
          <el-row :gutter="24" class="searchForm">
            <el-col :span="8" :xs="24">
              <label>学校类型：</label>
              <jm-dict-select
                clearable
                class="jm-input280"
                v-model="listInfoData.schoolMgId"
                type="dataset"
                dict-type="langschool_process"
                name="JpSchoolType"/>
            </el-col>
            <el-col :span="8" :xs="24">
              <label>学校：</label>
              <jm-school-search
                class="jm-input280"
                clearable
                filterable
                :country-id="83"
                v-model="schoolModel"/>
            </el-col>
            <el-col :span="8" :xs="24"
                    v-permission="[58,39,33]"
            >
              <label>文案小组：</label>
              <el-select
                class="jm-input280"
                v-model="listInfoData.writerTeam"
                placeholder="请选择"
                filterable
                clearable>
                <el-option
                  v-for="(option, index) in writerTeam.group_list"
                  v-if="listInfoData.roleid1 === option.group_role_id"
                  :key="index"
                  :label="`${option.group_name}(${option.truename})`"
                  :value="option.gid"/>
              </el-select>
            </el-col>
            <el-col :span="8" :xs="24"
                    v-permission="[58,39,33]"
            >
              <label>咨询小组：</label>
              <el-select
                class="jm-input280"
                v-model="listInfoData.advisoryTeam"
                placeholder="请选择"
                filterable
                clearable>
                <el-option
                  v-for="(option, index) in advisoryTeam.group_list"
                  v-if="listInfoData.roleid2 === option.group_role_id"
                  :key="index"
                  :label="`${option.group_name}(${option.truename})`"
                  :value="option.gid"/>
              </el-select>
            </el-col>
            <el-col :span="8" :xs="24">
              <label>入学时间：</label>
              <el-select v-model="listInfoData.startTime" clearable filterable placeholder="请选择" style="width:138px">
                <el-option
                  v-for="item in startTimeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="listInfoData.startTimeMonth" clearable filterable placeholder="请选择" style="width:138px">
                <el-option
                  v-for="item in startTimeMonthOps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8" :xs="24">
              <label>办理状态：</label>
              <el-select v-model="listInfoData.handleState"
                         style="width:138px"
                         clearable
                         multiple
                         placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="listInfoData.sub_status"
                         style="width:138px"
                         :disabled="listInfoData.handleState.indexOf('1') === -1"
                         clearable
                         placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8" :xs="24"
                    v-permission="[58,39,33]"
            >
              <label>文案老师：</label>
              <el-select
                class="jm-input280"
                v-model="listInfoData.crm_writer"
                placeholder="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in writerTeam.teacher"
                  v-if="filterTeacher(option, 1)"
                  :key="option.key"
                  :label="option.name"
                  :value="option.key"/>
              </el-select>
            </el-col>
            <el-col :span="8" :xs="24"
                    v-permission="[58,39,33]"
            >
              <label>咨询老师：</label>
              <el-select
                class="jm-input280"
                v-model="listInfoData.crm_advisory"
                placeholder="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in advisoryTeam.teacher"
                  v-if="filterTeacher(option, 2)"
                  :key="option.key"
                  :label="option.name"
                  :value="option.key"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="searchBottom">
              <el-button
                class="jm-input-common3"
                type="primary"
                @click="searchReport">搜索</el-button>
            </el-col>
          </el-row>
          <jm-tableList
            url="/index/jp_process/buildEnrolReportSql"
            :search-data="listInfoData"
            :refresh.sync="refresh"
            :page-size=100
            @expand-change="expandSelect"
          >
            <el-table-column slot="firstColumn" type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline v-for="(sub, index) in props.row.tmpArr" class="demo-table-expand" :key="index" v-if="props.row.Scount > 0">
                  <el-form-item>
                    <span>{{ sub.schoolname }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span>{{ sub.Scount }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span>{{ sub.One }}</span>
                  </el-form-item>
                  <el-form-item >
                    <span>{{ sub.Four }}</span>
                  </el-form-item>
                  <el-form-item >
                    <span>{{ sub.Seven }}</span>
                  </el-form-item>
                  <el-form-item >
                    <span>{{ sub.Ten }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span>{{ sub.Total }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              slot="schoolname"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="schoolname">
              <template slot-scope="scope">
                <span v-if="isColor(scope.row.sh_id)" style="color:red">
                  {{ scope.row.schoolname }}
                </span>
                <span v-else>
                  {{ scope.row.schoolname }}
                </span>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList.vue';
import { crumbs, jmAreaselect, jmSchoolSearch, jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      startTimeOptions: {},
      schoolModel: null,
      listInfoData: { // 初始数据
        schoolMgId: null, // 学校类型
        schoolId: {}, // 学校
        crm_writer: '', // 文案老师
        crm_advisory: '', // 咨询老师
        handleState: ['1'],
        sub_status: [], // 办理状态为开始时的子状态
        writerTeam: '',
        advisoryTeam: '',
        startTime: '',
        roleid1: '',
        startTimeMonth: '',
      },
      writeTeachers: '',
      advisoryTeachers: '',
      writerTeam: '',
      advisoryTeam: '',
      refresh: false,
      options: [{
        value: '1',
        label: '当期生',
      }, {
        value: '2',
        label: '已延期'
      }, {
        value: '3',
        label: '已退办'
      }, {
        value: '4',
        label: '未开始'
      }, {
        value: '5',
        label: '已入学'
      }],
      options2: [{
        value: '1',
        label: '正常'
      }, {
        value: '2',
        label: '异常'
      }],
      startTimeMonthOps: [{
        label: '一月期',
        value: 1,
      }, {
        label: '四月期',
        value: 4,
      }, {
        label: '七月期',
        value: 7,
      }, {
        label: '十月期',
        value: 10,
      }],
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmAreaselect,
    jmSchoolSearch,
    jmDictSelect
  },
  mounted() {
    this.getYears();
    this.getTeacherList();
    this.setYear();
  },
  methods: {
    searchReport() {
      if (Number(this.listInfoData.startTime) === 0) {
        this.$message.error('请选择入学时间');
        return false;
      }
      this.refresh = true;
    },
    getYears() {
      this.$http._get({
        url: '/index/jp_process/getYears',
        data: { flag: 5 }
      }).then((response) => {
        this.startTimeOptions = response.data;
      });
    },
    getTeacherList() {
      this.$http._get({
        url: '/index/jp_process/getTeacherList',
      }).then((response) => {
        this.writerTeam = Object.assign({}, this.writerTeam, response.data.writerTeacher);
        this.advisoryTeam = Object.assign({}, this.advisoryTeam, response.data.advisoryTeacher);
        this.listInfoData.roleid1 = typeof this.writerTeam.roleids === 'object' ? this.writerTeam.roleids[0].roleid : this.writerTeam.roleids;
        this.listInfoData.roleid2 = typeof this.advisoryTeam.roleids === 'object' ? this.advisoryTeam.roleids[0].roleid : this.advisoryTeam.roleids;
      });
    },
    setYear() {
      let date = new Date();
      let year = date.getFullYear();
      this.listInfoData.startTime = year + 1;
    },
    filterTeacher(option, val) {
      if (val === 1) {
        let group = (this.listInfoData.writerTeam && this.listInfoData.writerTeam === option.group_id) || !this.listInfoData.writerTeam;
        let roleid = (this.listInfoData.roleid1 && this.listInfoData.roleid1 === option.role_id) || !this.listInfoData.roleid1;
        return group && roleid;
      }
      let group = (this.listInfoData.advisoryTeam && this.listInfoData.advisoryTeam === option.group_id) || !this.listInfoData.advisoryTeam;
      let roleid = (this.listInfoData.roleid2 && this.listInfoData.roleid2 === option.role_id) || !this.listInfoData.roleid2;
      return group && roleid;
    },
    expandSelect(row, expandedRows) {
      if (expandedRows.length > 0) {
        let schoolId = row.sh_id ? row.sh_id : 0;
        this.$http._post({
          url: '/index/jp_process/schoolGroupSearch',
          data: { schoolGroupId: schoolId, searchData: this.listInfoData }
        }).then((response) => {
          row.tmpArr = response.data.data;
        });
      }
    },
    isColor(id) {
      // 学校高亮
      let arr = ['SG_4', '315', '4623', '342', '4628', '377', '3842', '3999', 'SG_2', '4650', '5920', 'SG_6', '373', '338', '868', 'SG_3', '371', '305', '3838', '309', '6042', '460', '5915'];
      if (arr.includes(id)) {
        return true;
      }
      return false;
    }
  },
  watch: {
    schoolModel(val) {
      this.listInfoData.schoolId = val ? val.sh_id : null;
    },
    'listInfoData.handleState'(val) {
      if (val.indexOf('1') === -1) {
        this.listInfoData.sub_status = null;
      }
    },
  }
};
</script>
<style scoped>
  .searchForm *{
    padding: 5px;
  }
  .demo-table-expand {
    font-size: 0;
    text-align:center;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 14.28%;
  }
</style>
